import { IOutlet } from "../../../model/outlet.model";
import { INewOutletsAction } from "../../action/new-outlets/new-outlets.action";

import { EACTIONS } from "../../action.enum";

export function reducer(state: Array<IOutlet> = [], action: INewOutletsAction) {
  switch (action.type) {
    case EACTIONS.SET_NEW_OUTLETS:
      return action.payload;
    case EACTIONS.REMOVE_NEW_OUTLETS:
      return [];

    default:
      return state ? state : [];
  }
}
